import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  const quickLinks = [
    { to: '/', label: t('nav.home') },
    { to: '/category/sports', label: t('nav.category') },
    { to: '/article/article-1', label: t('nav.articles') },
    { to: '/about', label: t('nav.about') },
  ];

  const legalLinks = [
    { to: '/about', label: t('footer.privacy') },
    { to: '/about', label: t('footer.terms') },
    { to: '/about', label: t('footer.disclaimer') },
    { to: '/about', label: t('footer.sitemap') },
  ];

  return (
    <footer className="bg-background-950 text-foreground-50">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="lg:col-span-1">
              <Link to="/" className="cursor-pointer">
                <span className="font-heading text-2xl font-bold text-background-50 tracking-tight">
                  kaiyun
                </span>
                <span className="text-sm text-foreground-400 ml-1">com</span>
              </Link>
              <p className="mt-3 text-sm text-foreground-300 leading-relaxed">
                {t('site.tagline')}
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
              <ul className="space-y-2.5">
                {quickLinks.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-300 hover:text-background-50 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">法律条款</h4>
              <ul className="space-y-2.5">
                {legalLinks.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-300 hover:text-background-50 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
              <ul className="space-y-2.5">
                <li className="flex items-start gap-2 text-sm text-foreground-300">
                  <i className="ri-mail-line mt-0.5 text-foreground-400" />
                  <span>service@kaiyun.com</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-foreground-300">
                  <i className="ri-phone-line mt-0.5 text-foreground-400" />
                  <span>400-XXX-XXXX</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-foreground-300">
                  <i className="ri-time-line mt-0.5 text-foreground-400" />
                  <span>7×24小时全天候在线</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; {year} kaiyun com {t('footer.rights')}
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-300 hover:text-background-50 hover:bg-primary-600 transition-colors duration-200 cursor-pointer">
                <i className="ri-wechat-line text-sm" />
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-300 hover:text-background-50 hover:bg-primary-600 transition-colors duration-200 cursor-pointer">
                <i className="ri-weibo-line text-sm" />
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-300 hover:text-background-50 hover:bg-primary-600 transition-colors duration-200 cursor-pointer">
                <i className="ri-links-line text-sm" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}